import { render, staticRenderFns } from "./_PreDeployWarning.vue?vue&type=template&id=2b6a7c3e"
import script from "./_PreDeployWarning.vue?vue&type=script&lang=ts"
export * from "./_PreDeployWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports